import moment from 'moment-timezone'

var dateFunctions = {
  getFormattedDate(datetime, format) {
    let zone = moment.tz.guess(true);
    if (zone) {
      let utcDateTime = moment.utc(datetime, "YYYYMMDDhhmmss");
      let userTimeZoneRaw = utcDateTime.tz(zone);
      let userTimeZoneFormatted = userTimeZoneRaw.format(format);
      return userTimeZoneFormatted;
    } else {
      return moment(datetime, "YYYYMMDDhhmmss").format(format);
    }
  },
  formatPalmDateTime(date, time) {
    if (!date) {
      return null;
    }
    if (!time) {
      time = "000000";
    }
    return this.formatPalmDateTimeCombined(date + time);
  },
  formatPalmDateTimeCombined(datetime) {
    let zone = moment.tz.guess(true);
    if (zone) {
      let utcDateTime = moment.utc(datetime, "YYYYMMDDhhmmss");
      let userTimeZoneRaw = utcDateTime.tz(zone);
      let userTimeZoneFormatted = userTimeZoneRaw.format(
        "MMM Do YYYY, HH:mm:ss"
      );
      return userTimeZoneFormatted;
    } else {
      return moment(datetime, "YYYYMMDDhhmmss").format(
        "MMM Do YYYY, HH:mm:ssZ"
      );
    }
  },
  formatPalmDateTimeShort(date, time) {
    if (!date) {
      return null;
    }
    if (!time) {
      time = "000000";
    }
    let zone = moment.tz.guess(true);
    if (zone) {
      let utcDateTime = moment.utc(date + time, "YYYYMMDDhhmmss");
      let userTimeZoneRaw = utcDateTime.tz(zone);
      let userTimeZoneFormatted = userTimeZoneRaw.format(
        "MMM Do YYYY, H:mm:ss"
      );
      return userTimeZoneFormatted;
    } else {
      return moment(date + time, "YYYYMMDDhhmmss").format(
        "MMM Do YYYY, H:mm:ss"
      );
    }
  },
  formatPalmDateISO(date) {
    if (!date) {
      return null;
    }
    let zone = moment.tz.guess(true);
    if (zone) {
      let utcDateTime = moment.utc(date, "YYYYMMDD");
      let userTimeZoneRaw = utcDateTime.tz(zone);
      let userTimeZoneFormatted = userTimeZoneRaw.format("YYYY-MM-DD");
      return userTimeZoneFormatted;
    } else {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    }
  },
  formatPalmDateTimeISO(date, time, includeSeconds) {
    if (!date) {
      return null;
    }
    if (!time) {
      time = "000000";
    }
		let timeFormat = (includeSeconds) ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm" ;
    let zone = moment.tz.guess(true);
    if (zone) {
      let utcDateTime = moment.utc(date + time, "YYYYMMDDhhmmss");
      let userTimeZoneRaw = utcDateTime.tz(zone);
      let userTimeZoneFormatted = userTimeZoneRaw.format(
        timeFormat
      );
      return userTimeZoneFormatted;
    } else {
      return moment(date + time, "YYYYMMDDhhmmss").format(
        timeFormat
      );
    }
  },
  formatPalmDate(date) {
    return moment(date, "YYYYMMDD").format("MMM Do YYYY");
  },
  deserialisePalmDate(date) {
    return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
  },
  serialisePalmDate(date) {
    return moment(date, "YYYY-MM-DD").format("YYYYMMDD");
  },
  serialisePalmDateTime(datetime) {
    return moment(datetime, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDHHmmss");
  },
};

export default dateFunctions